module.exports = __webpack_public_path__ + "img/Girl_020023.7495f291.png";